/*
   Video and Image Swiper

  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video
  https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/progress_event

*/

import Swiper, {
  Autoplay,
  Keyboard,
  Controller,
  EffectCards,
  Navigation,
  Pagination,
} from "swiper";

Swiper.use([
  Keyboard,
  Autoplay,
  Controller,
  EffectCards,
  Navigation,
  Pagination,
]);

class NoteSlider {
  constructor(app, _selector = ".note-slider") {
    this.blockSwiper = null;
    this.selector = _selector;
  }

  init = () => {
    console.log("Notes Slider.init:", window.captions);
    this.blockSwiper = new Swiper(this.selector, {
      // Optional parameters
      direction: "horizontal",
      loop: true,
      slidesPerView: 3,
      spaceBetween: 80,
      breakpoints: {
        // when window width is >= 320px
        600: {
          slidesPerView: 1,
          // spaceBetween: 20
        },
        // when window width is >= 480px
        900: {
          slidesPerView:3,
          // spaceBetween: 30
        },
        // when window width is >= 640px
        1400: {
          slidesPerView: 4,
          // spaceBetween: 40
        }
      },
      // mobile
      
      autoHeight: false,
      autoWidth: true,
      autoplay: {
        delay: 5000,
      },
      padding: 0,
      // height:'500px',
      // slidesPerView: '3',
      allowTouchMove: true,
      edgeSwipeDetection: false,
      allowSlideNext: true,
      allowSlidePrev: true,
      watchSlidesVisibility: true,
      centeredSlides: true,

      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      parallax: false,
      uniqueNavElements: false,
      preloadImages: false,
      // Enable lazy loading
      lazy: false,
      // If we need pagination
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-buttn-next",
        prevEl: ".swiper-buttn-prev",
      },
      pagination: false,
      // cssMode : true,
      // effect : 'slide', fade 'coverflow', cube ,creative
      effect: "slide",
      coverflowEffect: {
        rotate: 30,
        slideShadows: false,
      },
      fadeEffect: {
        crossFade: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      parallax: false,
      uniqueNavElements: false,
      preloadImages: true,
      // Enable lazy loading
      lazy: false,
      // If we need pagination
      // Navigation arrows
    });
    let prev_btn = document.getElementById("notes-button-prev");
    let next_btn = document.getElementById("notes-button-next");

    // prev_btn.addEventListener("click", app.noteSlider.prev);
    // next_btn.addEventListener("click", app.noteSlider.next);

    this.blockSwiper.on("slideChangeTransitionStart", this.onSwiperChange);
    console.log("this.swiper:", this.swiper);

    // this.swiper.start();
  };
  /// init

  updateProgress = () => {
    let totalSlides = this.blockSwiper.slides.length;
    let fragment = document
      .getElementById("home_fragment")
      .querySelectorAll("span");
    fragment[0].innerHTML = this.homeSwiper.realIndex + 1;
    fragment[1].innerHTML = totalSlides;
  };

  onSwiperChange = (e) => {
    console.log("HeroSlider.changed:", this.blockSwiper.realIndex);
    console.log("HeroSlider.changed:", this.blockSwiper);
    this.updateProgress();
    // app.globe.resize();
    // let canva = document.getElementById('vanta_globe').parentNode.parentNode;
    // canva.classList.add('swiper-slide-duplicate-active');
  };

  next = () => {
    this.blockSwiper.slideNext();
  };

  prev = () => {
    console.log("prev");
    this.blockSwiper.slidePrev();
  };
}

export default NoteSlider;
